import { makeBooleanDataField, makeStringDataField } from '@microsoft/oteljs';
export var STKAction = {
    contractName: 'Ms.ProductUsage.STKAction',
    instanceName: 'BaseType',
    /* Gets data fields for the Ms.ProductUsage.STKAction contract */
    getFields: function (contract) {
        var instName = this.instanceName;
        var dataFields = [];
        dataFields.push(makeStringDataField("zC.".concat(instName), this.contractName));
        if (contract.ver) {
            dataFields.push(makeStringDataField("".concat(instName, ".Ver"), contract.ver));
        }
        dataFields.push(makeStringDataField("".concat(instName, ".Name"), contract.name));
        dataFields.push(makeStringDataField("".concat(instName, ".FeatureName"), contract.featureName));
        if (contract.featureCategory) {
            dataFields.push(makeStringDataField("".concat(instName, ".FeatureCategory"), contract.featureCategory));
        }
        if (contract.inputMethod) {
            dataFields.push(makeStringDataField("".concat(instName, ".InputMethod"), contract.inputMethod));
        }
        dataFields.push(makeBooleanDataField("".concat(instName, ".IsExportable"), contract.isExportable));
        dataFields.push(makeBooleanDataField("".concat(instName, ".IsIntentional"), contract.isIntentional));
        if (contract.subWorkload) {
            dataFields.push(makeStringDataField("".concat(instName, ".SubWorkload"), contract.subWorkload));
        }
        if (contract.target) {
            dataFields.push(makeStringDataField("".concat(instName, ".Target"), contract.target));
        }
        dataFields.push(makeStringDataField("".concat(instName, ".FeatureActionType"), contract.featureActionType));
        return dataFields;
    }
};
//# sourceMappingURL=MsProductUsageSTKAction.js.map